import type { AudienceCustomer } from '@/components/audiences/audience-details-types';
import type { ListAudienceMembersResponseDto } from '@/generated/korza-api-client/types.gen';

type AudienceMemberDto = ListAudienceMembersResponseDto['data'][number];

export function mapAudienceMemberToCustomer(
  member: AudienceMemberDto
): AudienceCustomer {
  return {
    appUserId: member.appUserId,
    fullName: member.fullName,
    email: member.email,
    phone: member.phone,
    lastActiveAt: member.lastActiveAt,
    governmentId: member.governmentId,
    ecommerceCustomerId: member.ecommerceCustomerId,
  };
}
